import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import TRANSLATIONS from '../../translations/translations@default.json';
import { isAcceptedRegion } from '../../utilities/locale-utilities';
import OutOfStock from './OutOfStock/OutOfStock';

export const StockStatus = ({ stockStatus, alignCenter, classes }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (!stockStatus) {
		return null;
	}

	if (stockStatus === 'OutOfStock') {
		return (
			<OutOfStock
				classes={classnames({
					'mt-4 mb-auto': !CustomCategoriesEnabled,
					'mt-auto': CustomCategoriesEnabled,
				})}
			/>
		);
	}

	if (isAcceptedRegion(['AOL', 'ADE'])) {
		return null;
	}

	return (
		<div
			data-testid="stock-status__live-product"
			className={classnames(
				'flex font-bold text-body-xs items-center',
				classes,
				{
					'justify-center': alignCenter,
				}
			)}>
			<i className="ico ico-tick text-cta-main text-lg" />
			<div className="product-card__stock-text">
				{TRANSLATIONS.productList.productCard.stockStatus.inStock}
			</div>
		</div>
	);
};

export default StockStatus;
